import type { AuditAction, AuditLogEntry } from "@mc/types"
import { apiRequest } from "./httpClient.js"

export interface AuditLogQuery {
  serverId?: string
  actorId?: string
  action?: AuditAction
  from?: string
  to?: string
  cursor?: string
}

/** `/audit` (FR section 13). host_owner: any filters. Non-host_owner: `serverId` required, must own that server or have access.manage on it (enforced server-side, see services/gateway/src/routes/audit.ts). */
export function listAuditLog(query: AuditLogQuery = {}): Promise<{ entries: AuditLogEntry[] }> {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(query)) {
    if (value) params.set(key, value)
  }
  const qs = params.toString()
  return apiRequest(`/api/v1/audit${qs ? `?${qs}` : ""}`)
}
